import dynamic from "next/dynamic";
import React from "react";

import PageBuilder from "@brexhq/next/src/components/pageBuilder/PageBuilder";
import { FilteredArticlesContextProvider } from "@brexhq/next/src/contexts/FilteredArticlesContext";
import { PageBuilderRendererProps } from "@brexhq/next/types/pageBuilder";

export const components = {
  articleFooter: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/ArticleFooter/ArticleFooter"
    ).then((mod) => mod.ArticleFooter),
  ),
  billboard: dynamic(() =>
    import("@brexhq/next/src/components/modules/Billboard/Billboard").then(
      (mod) => mod.Billboard,
    ),
  ),
  calloutModule: dynamic(() =>
    import("@brexhq/next/src/components/modules/Callout/Callout").then(
      (mod) => mod.Callout,
    ),
  ),
  carouselModule: dynamic(() =>
    import("@brexhq/next/src/components/modules/Carousel/Carousel").then(
      (mod) => mod.Carousel,
    ),
  ),
  carouselWithContentModule: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/CarouselWithContent/index"
    ).then((mod) => mod.CarouselWithContent),
  ),
  columnsModule: dynamic(() =>
    import("@brexhq/next/src/components/modules/Columns/Columns").then(
      (mod) => mod.Columns,
    ),
  ),
  contentHubFilterSearch: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/ContentHubSearch/ContentHubFilterSearch"
    ).then((mod) => mod.ContentHubSearchFilter),
  ),

  customText: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/BlockRowsModule/BlockRowsModule"
    ).then((mod) => mod.BlockRowsModule),
  ),
  customerStories: dynamic(
    () =>
      import(
        "@brexhq/next/src/components/modules/CustomerStories/CustomerStoriesWrapper"
      ),
  ),
  faq: dynamic(() =>
    import("@brexhq/next/src/components/modules/FAQ/FAQ").then(
      (mod) => mod.FAQ,
    ),
  ),
  formMultistep: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/FormMultistep/FormMultistep"
    ).then((mod) => mod.FormMultistep),
  ),
  fullWidthVideo: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/FullWidthVideo/FullWidthVideo"
    ).then((mod) => mod.FullWidthVideo),
  ),
  imageModule: dynamic(() =>
    import("@brexhq/next/src/components/modules/MediaModule/MediaModule").then(
      (mod) => mod.MediaModule,
    ),
  ),
  inlineSSU: dynamic(() =>
    import(
      "@brexhq/next/src/components/building-blocks/InlineSignupForm/InlineSignupForm"
    ).then((mod) => mod.DeprecatedInlineSignupForm),
  ),
  inlineTextModule: dynamic(() =>
    import("@brexhq/next/src/components/modules/ArticleText/ArticleText").then(
      (mod) => mod.ArticleText,
    ),
  ),
  linkableLogoGridModule: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/LinkableLogoGrid/LinkableLogoGrid"
    ).then((mod) => mod.LinkableLogoGrid),
  ),
  logoGardenV2: dynamic(() =>
    import("@brexhq/next/src/components/modules/LogoGarden/LogoGarden").then(
      (mod) => mod.LogoGarden,
    ),
  ),
  jobsBoard: dynamic(() =>
    import("@brexhq/next/src/components/modules/JobsBoard/JobsBoard").then(
      (mod) => mod.JobsBoardModule,
    ),
  ),
  marketoForm: dynamic(
    () => import("@brexhq/next/src/components/modules/MarketoForm"),
  ),
  marqueeModule: dynamic(
    () => import("@brexhq/next/src/components/modules/Marquee"),
  ),
  multiColumn: dynamic(
    () =>
      import(
        "@brexhq/next/src/components/pageBuilder/Wrappers/MultiColumnWrapper"
      ),
  ),
  stories: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/ScrollingStory/ScrollingStory"
    ).then((mod) => mod.ScrollingStory),
  ),
  swipeCarousel: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/CarouselSwipeCards/CarouselSwipeCards"
    ).then((mod) => mod.CarouselSwipeCards),
  ),
  table: dynamic(() =>
    import("@brexhq/next/src/components/modules/Table/Table").then(
      (mod) => mod.Table,
    ),
  ),
  textOverImageModule: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/TextOverImage/TextOverImage"
    ).then((mod) => mod.TextOverImage),
  ),
  thirdPartyScript: dynamic(
    () =>
      import("@brexhq/next/src/components/modules/ThirdPartyJS/ThirdPartyJS"),
  ),
  repeatableContent: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/ContentRepeat/ContentRepeat"
    ).then((mod) => mod.ContentRepeat),
  ),
  cardsModule: dynamic(() =>
    import("@brexhq/next/src/components/modules/CardsModule/CardsModule").then(
      (mod) => mod.CardsModule,
    ),
  ),
  scrollingSubNav: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/ScrollingSubNavModule/ScrollingSubNavModule"
    ).then((mod) => mod.ScrollingSubNavModule),
  ),
  interactivePanel: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/InteractivePanel/InteractivePanel"
    ).then((mod) => mod.InteractivePanel),
  ),
  experiment: dynamic(() =>
    import("@brexhq/next/src/components/modules/Experiment/Experiment").then(
      (mod) => mod.Experiment,
    ),
  ),
  accordion: dynamic(() =>
    import("@brexhq/next/src/components/modules/Accordion/Accordion").then(
      (mod) => mod.Accordion,
    ),
  ),
  imagesGrid: dynamic(() =>
    import("@brexhq/next/src/components/modules/ImagesGrid").then(
      (mod) => mod.ImagesGrid,
    ),
  ),
  articleTabsModule: dynamic(() =>
    import("@brexhq/next/src/components/modules/ArticleTabs/ArticleTabs").then(
      (mod) => mod.ArticleTabs,
    ),
  ),
  calculator: dynamic(() =>
    import("@brexhq/next/src/components/modules/Calculator/Calculator").then(
      (mod) => mod.Calculator,
    ),
  ),
  stateMap: dynamic(() =>
    import("@brexhq/next/src/components/modules/StateMap/StateMap").then(
      (mod) => mod.StateMap,
    ),
  ),
  overlayPopup: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/OverlayPopup/OverlayPopup"
    ).then((mod) => mod.OverlayPopup),
  ),
  yieldSlider: dynamic(() =>
    import("@brexhq/next/src/components/modules/YieldSlider/YieldSlider").then(
      (mod) => mod.YieldSlider,
    ),
  ),
  leadFormWizard: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/LeadFormWizard/LeadFormWizard"
    ).then((mod) => mod.LeadFormWizard),
  ),
  fileDownloadLeadForm: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/FileDownloadLeadForm/FileDownloadLeadForm"
    ).then((mod) => mod.FileDownloadLeadForm),
  ),
  baseCalculator: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/BaseCalculator/BaseCalculator"
    ).then((mod) => mod.BaseCalculator),
  ),
  ctaModule: dynamic(() =>
    import("@brexhq/next/src/components/modules/CtaModule/CtaModule").then(
      (mod) => mod.CtaModule,
    ),
  ),
  signupForm: dynamic(() =>
    import(
      "@brexhq/next/src/components/modules/LeadForm/LeadFormBuildingBlock"
    ).then((mod) => mod.LeadFormBuildingBlock),
  ),
};

/**
 * Use this to render page builder components, see PageBuilderStoryRenderer for storybook use
 * @param data object that has corePageBuilder key
 * @returns PageBuilder component using all next specific components
 *
 */
const NextPageBuilderRenderer: React.FC<PageBuilderRendererProps> = ({
  blocks,
  repeatContentData,
}) => {
  return (
    <FilteredArticlesContextProvider value={repeatContentData}>
      <PageBuilder blocks={blocks} components={components as any} />
    </FilteredArticlesContextProvider>
  );
};

export default NextPageBuilderRenderer;
